import { render, staticRenderFns } from "./EssaySubmission.vue?vue&type=template&id=5bd8bc3d&scoped=true"
import script from "./EssaySubmission.vue?vue&type=script&lang=js"
export * from "./EssaySubmission.vue?vue&type=script&lang=js"
import style0 from "./EssaySubmission.vue?vue&type=style&index=0&id=5bd8bc3d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd8bc3d",
  null
  
)

export default component.exports